import { podEventsSlice } from './pod-events';

export const { animateNftEvent, clearNftEvents } = podEventsSlice.actions;
export const { reducer: podEventsReducer } = podEventsSlice;

export type { PodEventsState } from './types';
